<div class="d-block d-md-flex" *ngIf="{ articleNumber: articleNumber$ | async } as data">
  <ul class="d-flex align-items-center">
    <ng-container *ngIf="!data.articleNumber; else clearArticleFilterTemplate">
      <li (click)="clearFilter(breadcrumb)" class="d-flex align-items-center mr-2" *ngFor="let breadcrumb of breadcrumbs">
        {{ breadcrumb.facetValueName }}
        <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
      </li>
    </ng-container>

    <ng-template #clearArticleFilterTemplate>
      <li (click)="onResetFacets()" class="d-flex align-items-center mr-2">
        {{ data.articleNumber }}
        <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
      </li>
    </ng-template>
  </ul>

  <py-catalog-filter-reset
    class="d-flex justify-content-center my-3 my-md-0 ml-md-2"
    *ngIf="breadcrumbs?.length || !!data.articleNumber"
    (resetFacets)="onResetFacets()"
  ></py-catalog-filter-reset>

  <ng-template #iconTemplate>
    <i nz-icon pyIconThemeReverse class="ml-3" nzType="close-circle" nzTheme="outline"></i>
  </ng-template>
</div>
